import { Component, OnInit } from '@angular/core';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';

@Component({
  selector: 'app-email-basic',
  templateUrl: './email-basic.component.html',
  styleUrls: ['./email-basic.component.scss']
})

export class EmailBasicComponent implements OnInit {

  public breadCrumbItems!: Array<{}>;
  public ourCompanyName  : string=this.platformInviewService.getOurCompanyName();
  public year            : number=new Date().getFullYear();

  constructor(
    private platformInviewService: PlatformInviewService
  ) { }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Email' },
      { label: 'Basic Action', active: true }
    ];
  }
}
